<button
  pButton
  type="button"
  class="btn btn-default"
  [disabled]="userAccessLevel < 2"
  (click)="dulplicateClick()"
  icon="pi pi-copy"
></button>

<p-dialog
  #eventCopyModal
  [modal]="true"
  [(visible)]="showModal"
  [closable]="false"
  styleClass="atlas-dialog-s"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    {{ 'events.copy.component.title' | translate | titlecase }}
  </ng-template>

  <div class="container-fluid">
    <div class="row">
      <label>
        {{ 'events.copy.component.event-start-date-label' | translate | titlecase }}
      </label>
      <div>
        <wl-date-selector name="date" [(ngModel)]="eventCopy.NewStartDate"></wl-date-selector>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      class="btn btn-primary"
      (click)="copyEvent()"
      icon="pi pi-copy"
      [label]="'common.ok' | translate | titlecase"
    ></button>
    <button
      pButton
      type="button"
      class="btn btn-secondary"
      (click)="cancelClick()"
      icon="pi pi-ban"
      [label]="'common.cancel' | translate | titlecase"
    ></button>
  </ng-template>
</p-dialog>
